module.exports = __webpack_public_path__ + "img/TimberCove02.bfcee1f8.jpg";